import React, { useContext } from 'react';
import styled from 'styled-components';
import { AuthContext } from 'contexts';
import { Color } from '@bb/elements-web-rebranding';
import { SubscriptionsPageProvider } from './SubscriptionsPageContext';
import PaymentCard from './components/PaymentCard';
import ContactDetailsCard from './components/ContactDetailsCard';
import CurrentBenefitsCard from './components/CurrentBenefitsCard';
import DocumentsCard from './components/DocumentsCard';
import InvoicesCard from './components/InvoicesCard';

const SubscriptionsPaymentsPage: React.FC = () => {
  const { auth } = useContext(AuthContext);

  if (!auth?.org?.id) {
    return null;
  }

  return (
    <SubscriptionsPageProvider
      orgId={auth.org.id}
      billingCustomerNumber={auth.billingCustomerNumber}
    >
      <StyledPageWrapper>
        <StyledHeader>
          <h1>Subscriptions and Payments</h1>
        </StyledHeader>
        <StyledCardsContainer>
          <StyledCardRow>
            <PaymentCard />
          </StyledCardRow>
          <StyledCardRow>
            <CurrentBenefitsCard />
          </StyledCardRow>
          <StyledCardRow>
            <ContactDetailsCard />
          </StyledCardRow>
          <StyledCardRow>
            <InvoicesCard />
          </StyledCardRow>
          <StyledCardRow>
            <DocumentsCard />
          </StyledCardRow>
        </StyledCardsContainer>
      </StyledPageWrapper>
    </SubscriptionsPageProvider>
  );
};

export default SubscriptionsPaymentsPage;

const StyledPageWrapper = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const StyledHeader = styled.div`
  margin-bottom: 24px;
  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    color: ${Color.BLACK};
  }
`;

const StyledCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StyledCardRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  /* Make single cards span full width */
  &:has(> :only-child) {
    grid-template-columns: 1fr;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
